
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { Box } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { renderColorByString } from 'components/DataGrid/renderColorByString'
import { NcoStatusContainer } from 'styles/elements/styleElements'
import { DensityStyleTypes } from '../../../../types'

interface RenderSeoTierProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
}

const RenderSeoTierCell: React.FC<RenderSeoTierProps> = ({ params, densityStyles }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        padding: densityStyles.padding,
        gap: densityStyles.gap,
      }}
    >
      {params?.value ? (
        <NcoStatusContainer
          sx={{
            bgcolor: renderColorByString(params?.value),
            textAlign: 'center',
          }}
        >
          {params?.value}
        </NcoStatusContainer>
      ) : (
        <CheckCircleIcon
          sx={{
            height: '100%',
            color: 'rgb(96, 94, 94)',
            opacity: '0.2',
          }}
        />
      )}
    </Box>
  )
}
export default RenderSeoTierCell
